import {
  ICreateConsultingRequestResponse200,
  TCreateConsultingRequestResponse,
} from '../../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';
import { ResponseError } from '../../../utils/errors';

export function assertResponseError(
  response: TCreateConsultingRequestResponse,
): asserts response is ICreateConsultingRequestResponse200 {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/consultingRequest/createConsultingRequest#assertResponseError()',
    message: 'Failed creating consulting request',
    details: { message, errors },
  });
}
